<template>
  <v-container fluid style="z-index: 888 !important; padding: 10px; overflow-y: hidden; overflow-x: hidden;">
    <v-row>
        <!-- Logout -->
        <v-row>
            <v-col cols="12" align="end">
               <v-btn style=" background: #2ed7c7; color: white; height: 50px" @click="logout()">logout</v-btn>
            </v-col>
        </v-row>
        <!-- 左邊頁面-->
        <v-col cols="6" align="start">
            
            <v-card style="width: 100%;">
                <v-card-title primary-title>
                    <v-col cols="10" xs12 sm12 md12>
                        <!-- Artilux Logo圖 -->
                        <img src="https://www.artiluxtech.com/assets/img/public/logo-explore.svg">
                    </v-col>
                    <v-col cols="2" xs12 sm12 md12>
                        <v-btn style="background: #2ed7c7; color: white;" @click="reset_params()">reset</v-btn>
                    </v-col>
                </v-card-title>
                <v-card-text>
                <v-row>
                    <!-- 左邊欄位 -->
                    <v-col cols="12" xl="5" lg="5" md="5" sm="12">
                        <div class="borderStyle">
                            <v-select class="mt-6" v-model="data.sensor_model_id" :items="sensor_list" item-text="model_name" item-value="sensor_model_id" label="Sensor model" @change="selectSensor()" outlined>
                                <template slot="selection" slot-scope="data">                                    
                                    {{ data.item.model_name}}  {{ data.item.minor_version}}
                                </template>
                                <template slot="item" slot-scope="data">                                    
                                    {{ data.item.model_name}}  {{ data.item.minor_version}}
                                </template>
                            </v-select>
                        </div>
                        <div class="borderStyle">
                            <!-- <v-text-field class="mt-6" v-model="data.laser_peak_power_W" type="Number" min="0.0" step="0.1" max="99.9" label="Laser peak power (W)" :rules="[rules.emptyRules, rules.minNumber, rules.range31Number, rules.decimal31Number]" outlined></v-text-field> -->
                            <v-select v-model="laser" :items="laser_items" label="Laser peak power (W)" outlined></v-select>
                            <v-text-field v-model="data.tx_relative_illum" type="Number" min="0" step="1" max="100" label="Tx relative illumination (%)" :rules="[rules.emptyRules, rules.minNumber, rules.percentMaxNumber, rules.intNumber]" outlined></v-text-field>
                        </div>
                        <div class="borderStyle">
                            <v-select class="mt-6" v-model="object" :items="object_reflectivity_items" label="Object reflectivity (%)" outlined></v-select>
                            <!-- <v-text-field class="mt-6" v-model="data.object_reflectivity_percent" type="Number" min="1" max="100" label="Object reflectivity (%)" :rules="[rules.emptyRules, rules.min1Number, rules.percentMaxNumber, rules.intNumber]" outlined></v-text-field> -->
                            <!-- <v-text-field v-model="data.solar_ambient_lux" type="Number" min="0" label="Solar ambient light (Lux)" :rules="[rules.emptyRules, rules.minNumber, rules.intNumber]" outlined></v-text-field> -->
                            <v-select class="mt-6" v-model="solar" :items="solar_ambient_lux_items" label="Solar ambient light (Lux)" outlined></v-select>
                        </div>
                        <div class="borderStyle">
                            <!-- <v-text-field class="mt-6" v-model="data.lens_transmittance_percent" type="Number" min="1" max="100" label="Lens transmittance (%)" :rules="[rules.emptyRules, rules.min1Number, rules.percentMaxNumber, rules.intNumber]" outlined></v-text-field> -->
                            <v-select class="mt-6"  v-model="lens_trans" :items="lens_transmittance_items" label="Lens transmittance (%)" outlined></v-select>
                            <v-text-field v-model="data.lens_field_of_view_deg" type="Number" min="0" max="180" label="Lens field of view (degree)" :rules="[rules.emptyRules, rules.max180Number, rules.minNumber, rules.intNumber]" outlined></v-text-field>
                            <v-text-field v-model="data.lens_focal_number" type="Number" min="0.1" step="0.1" max="99.9" label="Lens focal number" :rules="[rules.emptyRules, rules.minDot1Number, rules.range31Number, rules.decimal31Number]" outlined></v-text-field>
                            <v-text-field v-model="data.lens_focal_length_mm" type="Number" min="0" step="0.1" max="99.9" label="Lens focal length (mm)" :rules="[rules.emptyRules, rules.minNumber, rules.range31Number, rules.decimal31Number]" outlined></v-text-field>
                            <v-text-field v-model="data.rx_relative_illum" type="Number" min="0" step="1" max="100" label="Rx relaive illumination (%)" :rules="[rules.emptyRules, rules.minNumber, rules.percentMaxNumber, rules.intNumber]" outlined></v-text-field>
                        </div>
                    </v-col>
                    <v-spacer></v-spacer>
                    <!-- 右邊欄位 -->
                    <v-col cols="12" xl="6" lg="6" md="6" sm="12">
                        <div class="borderStyle">
                            <!-- <v-text-field class="mt-6" v-model="data.bandpass_transmittance_percent" type="Number" min="1" max="100" label="Bandpass filter transmittance (%)" :rules="[rules.emptyRules, rules.min1Number, rules.percentMaxNumber, rules.intNumber]" outlined></v-text-field> -->
                            <v-select class="mt-6" v-model="bandpass" :items="bandpass_filter_list" label="Bandpass filter transmittance (%)" outlined></v-select>
                            <v-text-field v-model="data.bandpass_lower_nm" type="Number" min="0" label="Bandpass filter wavelength lower bound (nm)" :rules="[rules.emptyRules, rules.minNumber, rules.intNumber]" outlined></v-text-field>
                            <v-text-field v-model="data.bandpass_upper_nm" type="Number" min="0" label="Bandpass filter wavelength upper bound (nm)" :rules="[rules.emptyRules, rules.minNumber, rules.intNumber]" outlined></v-text-field>
                        </div>
                        <div class="borderStyle">
                            
                            <v-select 
                                class="mt-6" 
                                v-model="demod" 
                                :items="demod_frequency_mhz_list" 
                                item-text="demod_frequency_mhz"
                                item-value="demod_frequency_mhz"
                                label="Demodulation Frequency (MHz)"
                                :disabled="demod_frequency_mhz_list.length == 0" 
                                outlined>
                            </v-select>
                            <v-text-field v-model="data.exposure_time_per_quad_per_subframe_us" type="Number" min="0" label="Exposure time per quad per subframe (us)" :rules="[rules.emptyRules, rules.minNumber, rules.intNumber]" outlined></v-text-field>
                            <v-text-field v-model="data.subframe_number" type="Number" min="0" label="Subframe number (#)" :rules="[rules.emptyRules, rules.minNumber, rules.intNumber]" outlined></v-text-field>
                            <v-select 
                                v-model="data.capacitance_fF" 
                                :items="capacitance_list" 
                                item-text="analog_gain"
                                item-value="capacitance_fF"
                                label="Analog gain" 
                                :disabled="capacitance_list.length == 0" 
                                outlined
                            >
                                <!-- 讓v-select 顯示被選擇item時可顯示 x1-25 的形式 -->
                                <!-- <template slot="selection" slot-scope="data">
                                    {{ data.item.analog_gain }} - {{ data.item.capacitance_fF }}
                                </template> -->
                                <!-- 讓v-select 選擇item時顯示 x1-25 的形式 -->
                                <!-- <template slot="item" slot-scope="data">
                                    {{ data.item.analog_gain }} - {{ data.item.capacitance_fF }}
                                </template>                  -->
                            </v-select>
                            <v-select v-model="data.temperature_C" :items="temperature_C_list" label="Temperature (°C)" :disabled="temperature_C_list.length == 0" outlined></v-select>
                        </div>
                        <div class="borderStyle">
                            <v-select class="mt-6" v-model="data.depth_variance_unit" :items="depth_list" label="Depth error unit" outlined></v-select>
                            <!-- <v-text-field v-model="data.range_m" type="Number" min="0.1" step="0.1" max="99.9" label="Range (m)" :rules="[rules.emptyRules, rules.minDot1Number, rules.range31Number, rules.decimal31Number]" outlined></v-text-field> -->
                            <!-- <v-select class="mt-6" v-model="data.depth_error_unit" :items="depth_list" label="Depth error unit" outlined></v-select> -->
                            
                            <v-select class="mt-6" v-model="range" :items="range_list" label="Range (m)" outlined></v-select>
                            <!-- <v-text-field v-model="data.range_m" type="Number" min="0.1" step="0.1" max="99.9" label="Range (m)" :rules="[rules.emptyRules, rules.minDot1Number, rules.range31Number, rules.decimal31Number]" outlined></v-text-field> -->
                        </div>
                    </v-col>
                </v-row>
                </v-card-text>
                <v-card-actions>
                <a class="a-aim-btn" style="width: 100%">
                    <span class="a-aim-btn__deco -top"></span>
                    <span class="a-aim-btn__deco -bottom"></span>
                    <span class="a-aim-btn__main" @click="output()">
                    <span class="a-aim-btn__main-text">Enter</span>
                    </span>
                </a>
                </v-card-actions>
            </v-card>
        </v-col>
        <!-- 右邊頁面 Output image -->
        <v-col v-if="outputResult" cols="6" align="center">
            <v-card style=" width: 100%;">
                <v-card-title primary-title >
                <v-row align="center">
                    <v-col>
                    <span>Unambiguous Range: {{ outputData.unambiguous_range_m }}m</span>
                    </v-col>
                </v-row>
                </v-card-title>
                <v-card-text>
                <v-row align="center">
                    <v-col cols="12">
                        <img :src="'data:image/jpeg;base64,'+outputData.center_png.data">
                    </v-col>
                </v-row>
                <v-row align="center">
                    <v-col cols="12">
                        <img :src="'data:image/jpeg;base64,'+outputData.corner_png.data">
                    </v-col>
                </v-row>
                </v-card-text>       
            </v-card>
            
        </v-col>
    </v-row>
    <v-row>
    <v-dialog style="z-index: 890 !important;" v-model="submit_flag" persistent width="250" scrollable >
        <v-layout align-center justify-center style="height: 80px;">
            <h2>{{dialog_msg}}</h2>
        </v-layout>
    </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios'

var host_url = process.env.VUE_APP_HOST_URL
var laser_list = JSON.parse(process.env.VUE_APP_LASER_PEAK_POWER_LIST)
var object_list = JSON.parse(process.env.VUE_APP_OBJECT_REFLECTIVITY_LIST)
var solar_list = JSON.parse(process.env.VUE_APP_SOLAR_AMBIENT_LUX_LIST)
var lens_list = JSON.parse(process.env.VUE_APP_LENS_TRANSMITTANCE_LIST)
var bandpass_list =JSON.parse(process.env.VUE_APP_BANDPASS_TRANSMITTANCE_LIST)
var range_m_list = JSON.parse(process.env.VUE_APP_RANGE_LIST)

export default {
    data() {
        return {
            dialog: true,
            data: {
                sensor_model_id: null, 
                laser_peak_power_W: 0.5,
                tx_relative_illum: 0,
                object_reflectivity_percent: 10,
                solar_ambient_lux: 100,
                lens_transmittance_percent: 10,
                lens_field_of_view_deg: 0,
                lens_focal_number: 0.1,
                lens_focal_length_mm: 0.0,
                rx_relative_illum: 0,
                bandpass_transmittance_percent: 10,
                bandpass_lower_nm: 0,
                bandpass_upper_nm: 0,
                demod_frequency_mhz: null,
                exposure_time_per_quad_per_subframe_us: 0,
                subframe_number: 0,
                capacitance_fF: null,
                temperature_C: 0,
                depth_variance_unit: '%',
                range_m: 1,
                login_id: localStorage.getItem('login_id')
            },
            sensor_list: [],
            demod_frequency_mhz_list: [],
            capacitance_list: [],
            temperature_C_list: [-20, -15, -10, -5, 0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85],
            depth_list: ['%', 'mm'],
            outputResult: false,
            outputData: {
                center_png: { data: '' },
                corner_png: { data: '' },
            },
            
            demod: null,
            //新修改需要參數
            laser: 0.5,
            object: 10,
            solar: 100,
            lens_trans: 10,
            bandpass: 10,
            range: 1,    
        
            // 檢查輸入值型態
            checkInteger: /^[-+]?\d+$/,
            checkDecimal31: /^[-+]?[0-9]{0,2}?(?:\.[0-9]{0,1})?$/,
            checkDecimal32: /^[-+]?[0-9]{0,1}?(?:\.[0-9]{0,2})?$/,
            checkDecimal74: /^[-+]?[0-9]{0,3}?(?:\.[0-9]{0,4})?$/,
            rules: {
                emptyRules: v => (v !== '') || 'This field cannot be empty',
                minNumber: v => v >= 0 || 'The minimum value is 0',
                min1Number: v => v >=1 || 'The minimum value is 1',
                minDot1Number: v => v >= 0.1 || 'The minimum value is 0.1',
                percentMaxNumber: v => v <= 100 || 'The maximum value is100',
                max180Number: v => v <= 180 || "Only value from 0 to 180 is acceptable",
                intNumber: v => this.checkInteger.test(v) || "Only integer number is acceptable",
                range31Number: v => v <= 99.9 || "Only value from 00.0 to 99.9 is acceptable",
                range32Number: v => v <= 9.99 || "Only value from 0.00 to 9.99 is acceptable",
                range74Number: v => (v >= -999.9999 && v <= 999.9999) || "Only value from -999.9999 to 999.9999 is acceptable",
                decimal31Number: v => this.checkDecimal31.test(v) || "This field will be rounded to XX.X",
                decimal32Number: v => this.checkDecimal32.test(v) || "This field will be rounded to X.XX",
                decimal74Number: v => this.checkDecimal74.test(v) || "This field will be rounded to XXX.XXXX",
            },

            // 新改參數型式
            laser_items: laser_list, //step by 0.5
            object_reflectivity_items: object_list,  //step by 10
            solar_ambient_lux_items: solar_list,
            lens_transmittance_items: lens_list, //step by 10
            bandpass_filter_list: bandpass_list, //step by 5
            range_list: range_m_list, //step by 0.5

            submit_flag: false,
            dialog_msg: 'Computing..',

            unambiguous_range_m: 0,
        
        }
    },
    created(){
        this.getAllList()
        let login_id = localStorage.getItem('login_id')
        this.data.login_id = login_id
    },
    methods:{
        getAllList(){
            axios.get(host_url+ 'itof/sensor_list/')
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    this.sensor_list = tmp.data
                    console.log(this.sensor_list)
                }    
            })
            .catch((error) => {
                console.error(error)
            })
        },
        selectSensor(){
            console.log(this.data.sensor_model_id)
            axios.post(host_url+ 'itof/get_list/', {'sensor_model_id': this.data.sensor_model_id})
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    this.capacitance_list = tmp.data.capacitance_list
                    this.demod_frequency_mhz_list = tmp.data.demod_frequency_mhz_list
                    for (let i of this.capacitance_list){
                        if(i.default == true){
                            this.data.capacitance_fF = i.capacitance_fF
                        }
                    }
                    for (let i of this.demod_frequency_mhz_list){
                        if (i.default == true){
                            this.demod = i.demod_frequency_mhz
                        }
                    }
                }
            })
            .catch((error) => {
                console.error(error)
            })
        },
        output(){
            // 檢查是否有選擇以下5個參數
            console.log(this.data.sensor_model_id)
            if(this.data.sensor_model_id == null || this.data.sensor_model_id == undefined){ alert('Please select one sensor model'); return }

            else if(!this.laser){ alert('Please select a value for Laser peak power (W)'); return }
            else if(!this.object){ alert('Please select a value for Object reflectivity (%)'); return }
            else if(!this.solar){ alert('Please select a value for Solar ambient light (Lux)'); return }
            else if(!this.lens_trans){ alert('Please select a value for Lens transmittance (%)'); return }
            else if(!this.bandpass){ alert('Please select a value for Bandpass filter transmittance (%)'); return }
            else if(!this.demod){ alert('Please select a value for demod_frequency_mhz'); return }
            else if(!this.range){ alert('Please select a value for Range(m)'); return }
            else if(!this.data.capacitance_fF){ alert('Please select a value for analog gain'); return }
            else if(this.data.temperature_C == null){ alert('Please select a value for temperature'); return }
            else if(!this.data.depth_variance_unit){ alert('Please select the unit for the depth variance'); return }
            let check_status = this.checkValues()
            if(check_status == false){
                alert('Please check every field is correct');

                return
            }
            else{
                this.setValuesToFixed()
            }
            // console.log(this.data)
            // 送出到後端Server compute
            console.log(this.data)

            this.submit_flag = true
            axios.post(host_url+'itof/compute/', {'data': this.data})
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    this.outputResult = false
                    // console.log(tmp)
                    this.outputData = tmp.data
                    console.log(this.outputData)
                    this.outputResult = true
                }
                else{
                    alert(tmp.msg)
                }
                this.submit_flag = false

            })  
            .catch((error) => {
                console.error(error)
                this.submit_flag = false
                alert('Output error ! please check everything not wrong')
            })      
            
        },
        checkValues(){
            let check_status = true
            this.setValuesToFixed()
            if(!this.checkDecimal31.test(this.data.laser_peak_power_W) || this.data.laser_peak_power_W < 0 || this.data.laser_peak_power_W > 99.9 || this.data.laser_peak_power_W === ''){ check_status = false}
            if(!this.checkInteger.test( this.data.tx_relative_illum) || this.data.tx_relative_illum < 0 || this.data.tx_relative_illum > 100 || this.data.tx_relative_illum === ''){ check_status = false}
            if(!this.checkInteger.test(this.data.object_reflectivity_percent) || this.data.object_reflectivity_percent < 1 || this.data.object_reflectivity_percent > 100  || this.data.object_reflectivity_percent === ''){ check_status = false}
            if(!this.checkInteger.test(this.data.solar_ambient_lux) || this.data.solar_ambient_lux < 0 || this.data.solar_ambient_lux === ''){ check_status = false}
            if(!this.checkInteger.test(this.data.lens_transmittance_percent) || this.data.lens_transmittance_percent < 1 || this.data.lens_transmittance_percent > 100 || this.data.lens_transmittance_percent === ''){ check_status = false}
            if(!this.checkInteger.test(this.data.lens_field_of_view_deg) || this.data.lens_field_of_view_deg < 0 || this.data.lens_field_of_view_deg > 180 || this.data.lens_field_of_view_deg === ''){ check_status = false}
            if(!this.checkDecimal31.test(this.data.lens_focal_number) || this.data.lens_focal_number < 0.1 || this.data.lens_focal_number > 99.9 || this.data.lens_focal_number === ''){ check_status = false}
            if(!this.checkDecimal31.test(this.data.lens_focal_length_mm) || this.data.lens_focal_length_mm < 0 || this.data.lens_focal_length_mm > 99.9 || this.data.lens_focal_length_mm === ''){ check_status = false}
            if(!this.checkInteger.test( this.data.rx_relative_illum) || this.data.rx_relative_illum < 0 || this.data.rx_relative_illum > 100 || this.data.rx_relative_illum === ''){ check_status = false}
            if(!this.checkInteger.test(this.data.bandpass_transmittance_percent) || this.data.bandpass_transmittance_percent < 1 || this.data.bandpass_transmittance_percent > 100 || this.data.bandpass_transmittance_percent === ''){ check_status = false}
            if(!this.checkInteger.test(this.data.bandpass_lower_nm) || this.data.bandpass_lower_nm < 0 || this.data.bandpass_lower_nm === ''){ check_status = false}
            if(!this.checkInteger.test(this.data.bandpass_upper_nm) || this.data.bandpass_upper_nm < 0 || this.data.bandpass_upper_nm === ''){ check_status = false}
            if(!this.checkInteger.test(this.data.exposure_time_per_quad_per_subframe_us) || this.data.exposure_time_per_quad_per_subframe_us < 0 || this.data.exposure_time_per_quad_per_subframe_us === ''){ check_status = false}
            if(!this.checkInteger.test(this.data.subframe_number) || this.data.subframe_number < 0 || this.data.subframe_number === ''){ check_status = false}
            if(!this.checkDecimal31.test(this.data.range_m) || this.data.range_m < 0.1 || this.data.range_m > 99.9 || this.data.range_m === ''){ check_status = false}
            
            this.data.demod_frequency_mhz = typeof(this.demod) === 'string' ? Number(this.demod) : this.demod
            this.data.object_reflectivity_percent = typeof(this.object) === 'string' ? Number(this.object): this.object
            this.data.solar_ambient_lux = typeof(this.solar) === 'string' ? Number(this.solar): this.solar
            this.data.lens_transmittance_percent = typeof(this.lens_trans) === 'string' ? Number(this.lens_trans): this.lens_trans
            this.data.bandpass_transmittance_percent = typeof(this.bandpass) === 'string' ? Number(this.bandpass): this.bandpass
            this.data.range_m = typeof(this.range) === 'string' ? Number(this.range): this.range
            this.data.laser_peak_power_W = typeof(this.laser) === 'string' ? Number(this.laser): this.laser

            
            return check_status
        },
        setValuesToFixed(){
            this.data.laser_peak_power_W = parseFloat(this.laser).toFixed(1)
            this.data.lens_focal_number = parseFloat(this.data.lens_focal_number).toFixed(1)
            this.data.lens_focal_length_mm = parseFloat(this.data.lens_focal_length_mm).toFixed(1)
            this.data.demod_frequency_mhz = parseFloat(this.demod).toFixed(4)
            this.data.range_m = parseFloat(this.range).toFixed(1)
        },
        logout(){
            let login_id = localStorage.getItem('login_id')
            // console.log(login_id)
            axios.post(host_url + 'account/logout/', JSON.stringify({'login_id': login_id}))
            .then(response => {
                localStorage.removeItem('login_id')
                this.$router.push('/login')
            })
            .catch((error) => {
                console.error(error)
            })
        },
        reset_params(){
            this.demod= null
            this.laser= 0.5
            this.object= 10
            this.solar= 100
            this.lens_trans= 10
            this.bandpass= 10
            this.range= 1  
            this.data.sensor_model_id = null
            this.data.tx_relative_illum = 0	
            this.data.lens_field_of_view_deg = 0
            this.data.lens_focal_number = 0.1
            this.data.lens_focal_length_mm = 0.0	
            this.data.rx_relative_illum = 0
            this.data.bandpass_lower_nm = 0
            this.data.bandpass_upper_nm = 0
            this.data.exposure_time_per_quad_per_subframe_us= 0
            this.data.subframe_number= 0
            this.data.capacitance_fF= null
            this.data.temperature_C= 0
            this.data.depth_variance_unit= '%'
        },
    
    }   
}

</script>
<style scoped>
.borderStyle {
  border: 3px lightgray solid;
  margin-top: 20px;
  border-radius: 10px;
  padding: 5px;
}
</style>